import React from 'react';

import AssistantAvatar from '../AssistantAvatar';

import './typing-indicator.scss';

const TypingIndicator = () => (
  <li className="messages__msg outgoing">
    <div className="messages__msg_container">
      <AssistantAvatar typeAvatar="bubble" />
      <div className="typing-indicator">
        <span />
        <span />
        <span />
      </div>
    </div>
  </li>
);

export default TypingIndicator;
